import { useEffect, useState } from 'react';
import { type Config, loadConfig } from '../utils/config';

export const useConfig = () => {
  const [config, setConfig] = useState<Config | null>(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadConfig().then((loadedConfig) => {
      setConfig(loadedConfig);
      setLoaded(true);
    });
  }, []);

  return { config, loaded };
};
